module.exports = __webpack_public_path__ + "fonts/icomoon.4b0c450.eot";